import Pazienti from "../";

const routes = [
    { name: "PazientiList", path: "/pazienti", component: Pazienti.PazientiList, meta: { title: "pazienti.lblTitle" } },
    { name: "PazienteEdit", path: "/pazienti/edit/:id", component: Pazienti.PazientiEdit, meta: { title: "pazienti.lblTitle" } },
];

export default routes;
